//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BrigadeMapTaskCard from './BrigadeMapTaskCard.vue'
import BrigadeMapTasksList from './BrigadeMapTasksList.vue'
import { brigadeMapTasksListUtils } from './BrigadeMapTasksListUtils.js'

export default {
  components: {
    BrigadeMapTaskCard,
    BrigadeMapTasksList
  },
  mixins: [brigadeMapTasksListUtils],
  props: {
    performedRequests: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      openedDeparturePerformedRequestsConfig: null,
      closedDeparturePerformedRequestsConfig: null
    }
  },
  watch: {
    performedRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('openedDeparturePerformedRequestsConfig', requests.filter(request => !request.departureFinished))
        this.prepareRequestsListConfig('closedDeparturePerformedRequestsConfig', requests.filter(request => request.departureFinished))
      },
      immediate: true
    }
  }
}

